import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import styles from "../../assets/scss/Expense/AddExpensePopup.module.scss";
import { BaseURL } from "../../lib/api";
import Select from "react-select";

const AddExpensePopup = ({ mode = "add", data, onClose, onSave }) => {
  const [form, setForm] = useState({
    category: "",
    paymentType: "",
    paymentDate: null,
    amount: "",
    description: "",
    attachment: null,
    paymentStatus: "",
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

// ✅ Fix for image/attachment URLs (supports both local & full URLs)
const resolveFileUrl = (path) => {
  if (!path) return null;
  return path.startsWith("http") ? path : `${BaseURL}/${path}`;
};

  const expenseCategories = [
    "Miscellaneous",
    "Transportation & Travel Expense",
    "Telephone & Internet Bills",
    "Repair & Maintenance",
    "Rent Expense",
    "Raw Material",
    "Printing and Stationery",
    "Employee Salaries & Advances",
    "Electricity Bill",
    "Bank Fee and Charges",
  ].map((cat) => ({ value: cat, label: cat }));

  useEffect(() => {
    if (data) {
      setForm({
        category: data.category || "",
        paymentType: data.paymentMethod || "",
        paymentDate: data.paymentDate ? new Date(data.paymentDate) : null,
        amount: data.amount || "",
        description: data.description || "",
      //  attachment: data.attachment ? `${BaseURL}/${data.attachment}` : null,
      attachment: resolveFileUrl(data.attachment),
        paymentStatus: data.paymentStatus || "",
      });
    }
  }, [data]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      setForm((prev) => ({ ...prev, [name]: files[0] }));
    } else {
      setForm((prev) => ({ ...prev, [name]: value }));
    }
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleRemoveAttachment = () =>
    setForm((prev) => ({ ...prev, attachment: null }));

  const validate = () => {
    const newErrors = {};
    if (!form.category) newErrors.category = "Expense Category is required";
    if (!form.paymentType) newErrors.paymentType = "Payment Type is required";
    if (!form.paymentDate) newErrors.paymentDate = "Payment Date is required";
    if (!form.paymentStatus) newErrors.paymentStatus = "Payment Status is required";
    if (!form.amount) newErrors.amount = "Amount is required";
   // if (!form.description) newErrors.description = "Description is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setLoading(true);

    try {
      const formData = new FormData();
      formData.append("category", form.category);
      formData.append("paymentMethod", form.paymentType);
      formData.append("paymentStatus", form.paymentStatus);
      formData.append(
        "paymentDate",
        form.paymentDate ? formatDate(form.paymentDate) : ""
      );
      formData.append("amount", form.amount);
      formData.append("description", form.description || "");
      if (form.attachment && typeof form.attachment !== "string") {
        formData.append("attachment", form.attachment);
      }

      let token = localStorage.getItem("token");
      if (token?.startsWith('"') && token?.endsWith('"')) token = token.slice(1, -1);

      if (data?._id) {
        await axios.put(`${BaseURL}/expense/update/${data._id}`, formData, {
          headers: { authorization: token },
        });
        toast.success("Expense updated successfully!");
      } else {
        await axios.post(`${BaseURL}/expense/create`, formData, {
          headers: { authorization: token },
        });
        toast.success("Expense added successfully!");
      }

      onSave();
      onClose();
    } catch (error) {
      console.error("Error:", error);
      const message =
        error.response?.data?.message || error.message || "Failed to save expense";
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.popupForm}>
      {/* Header */}
      <div className={styles.header}>
        <h2 className={styles.tittle}>
          {mode === "add" && "Add Expense"}
          {mode === "edit" && "Edit Expense"}
          {mode === "view" && "View Expense"}
        </h2>
        <span className={styles.closeIcons} onClick={onClose}>
          ✕
        </span>
      </div>

      {/* Form */}
      <div className={styles.closeIcon}>
        <form id="expenseForm" className={styles.grid} onSubmit={handleSubmit}>
          {/* Attachment */}
          <div className={styles.uploadBox}>
            <label className={styles.inputLabel}>Attachment</label>
            <div className={styles.imageBox}>
              <div className={styles.dropArea}>
                {mode !== "view" && !form.attachment && (
                  <label className={styles.uploadLabel}>
                    <input
                      type="file"
                      name="attachment"
                      accept=".jpg,.jpeg,.png,.pdf"
                      onChange={handleChange}
                      className={styles.hiddenInput}
                    />
                    <span className={styles.uploadBtn}>+ Choose File</span>
                  </label>
                )}

                {form.attachment && (
                  <div className={styles.previewWrapper}>
                    {typeof form.attachment === "string" ? (
                      form.attachment.endsWith(".pdf") ? (
                        <a
                          href={form.attachment}
                          target="_blank"
                          rel="noopener noreferrer"
                          className={styles.fileName}
                        >
                          View PDF
                        </a>
                      ) : (
                        <img
                          src={form.attachment}
                          alt="Attachment"
                          className={styles.previewImage}
                        />
                      )
                    ) : form.attachment.type?.includes("image") ? (
                      <img
                        src={URL.createObjectURL(form.attachment)}
                        alt="Preview"
                        className={styles.previewImage}
                      />
                    ) : (
                      <p className={styles.fileName}>{form.attachment.name}</p>
                    )}
                    {mode !== "view" && (
                      <button
                        type="button"
                        className={styles.removeBtn}
                        onClick={handleRemoveAttachment}
                      >
                        ✕
                      </button>
                    )}
                  </div>
                )}
              </div>

            </div>
          </div>

          {/* Expense Category */}
          {/* <div className={styles.inputGroup}>
            <label className={styles.inputLabel}>Expense Category</label>
            <input
              type="text"
              name="category"
              value={form.category}
              onChange={handleChange}
              className={styles.input}
              placeholder="Enter category"
              disabled={mode === "view"}
            />
            {errors.category && <span className={styles.error}>{errors.category}</span>}
          </div> */}
          {/* Expense Category */}
          <div className={styles.inputGroup}>
            <label className={styles.inputLabel}>Expense Category</label>
            <Select
              className={styles.customSelect}
              isDisabled={mode === "view"}
              styles={{
                control: (base) => ({
                  ...base,
                  border: "1px solid #6D6D6D",
                  borderRadius: "6px",
                  fontSize: "16px",
                  minHeight: "50px",
                  boxShadow: "none",
                  color: "black",
                  fontWeight: "600",
                }),
                placeholder: (base) => ({
                  ...base,
                  color: "#6D6D6D",
                  fontSize: "16px",
                  fontWeight: "600",
                }),
              }}
              value={
                form.category
                  ? { value: form.category, label: form.category }
                  : null
              }
              onChange={(selectedOption) =>
                setForm((prev) => ({ ...prev, category: selectedOption ? selectedOption.value : "" }))
              }
              options={expenseCategories}
              placeholder="Select Expense Category"
              isSearchable
            />
            {errors.category && <span className={styles.error}>{errors.category}</span>}
          </div>

          {/* Payment Type */}
          <div className={styles.inputGroup}>
            <label className={styles.inputLabel}>Payment Type</label>
            <select
              name="paymentType"
              value={form.paymentType}
              onChange={handleChange}
              className={styles.inputs}
              disabled={mode === "view"}
            >
              <option value="">Select Type</option>
              <option value="cash">Cash</option>
              <option value="upi">UPI</option>
              <option value="bank">Bank Transfer</option>
            </select>
            {errors.paymentType && <span className={styles.error}>{errors.paymentType}</span>}
          </div>

          {/* Payment Status */}
          <div className={styles.inputGroup}>
            <label className={styles.inputLabel}>Payment Status</label>
            <select
              name="paymentStatus"
              value={form.paymentStatus}
              onChange={handleChange}
              className={styles.inputs}
              disabled={mode === "view"}
            >
              <option value="">Select Status</option>
              <option value="paid">Paid</option>
              <option value="pending">Pending</option>
            </select>
            {errors.paymentStatus && <span className={styles.error}>{errors.paymentStatus}</span>}
          </div>

          {/* Payment Date */}
          <div className={styles.inputGroup}>
            <label className={styles.inputLabel}>Payment Date</label>
            <DatePicker
              selected={form.paymentDate}
              onChange={(date) =>
                setForm((prev) => ({ ...prev, paymentDate: date }))
              }
              dateFormat="yyyy-MM-dd"
              placeholderText="Select date"
              className={styles.input}
              disabled={mode === "view"}
              maxDate={new Date()}
            />
            {errors.paymentDate && <span className={styles.error}>{errors.paymentDate}</span>}
          </div>

          {/* Amount */}
          <div className={styles.inputGroup}>
            <label className={styles.inputLabel}>Amount</label>
            <input
              type="number"
              name="amount"
              value={form.amount}
              onChange={handleChange}
              className={styles.input}
              placeholder="Enter amount"
              disabled={mode === "view"}
            />
            {errors.amount && <span className={styles.error}>{errors.amount}</span>}
          </div>

          {/* Description */}
          <div className={styles.inputGroupFull}>
            <label className={styles.inputLabel}>Description</label>
            <textarea
              name="description"
              value={form.description}
              onChange={handleChange}
              className={styles.input}
              placeholder="Enter description"
              disabled={mode === "view"}
            />
            {errors.description && <span className={styles.error}>{errors.description}</span>}
          </div>
        </form>

        {/* Footer Buttons */}
        <div className={styles.footerButtons}>
          <button type="button" className={styles.cancel} onClick={onClose}>
            {mode === "view" ? "Close" : "Cancel"}
          </button>
          {mode !== "view" && (
            <button
              type="submit"
              form="expenseForm"
              className={styles.saves}
              disabled={loading}
            >
              {mode === "add" ? "Save" : "Update"}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddExpensePopup;
